import type { QuoteStatus } from "@school-sales-ai/shared";
import { QUOTE_STATUS_META } from "@/lib/quote-status-meta";
import { cn } from "@/lib/utils";

export function QuoteStatusBadge({ status }: { status: QuoteStatus }): React.JSX.Element {
  const meta = QUOTE_STATUS_META[status];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11.5px] font-medium",
        meta?.className ?? "bg-ink-050 text-ink-600",
      )}
    >
      {/* A status from a newer build renders raw rather than blank: the column is
          a VarChar precisely so the vocabulary can grow. */}
      {meta?.label ?? status}
    </span>
  );
}
